export default "__VITE_ASSET__4d5f415a__"